<app-content>
  <app-breadcrumbs>
    <li>
      Jak korzystać
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Jak korzystać
    </h2>
    <br>
    <h3><a href="./instrukcjaUzytkownika.pdf" target="_blank">Instrukcja użytkownika</a></h3>
    <br />
    <div class="row">
      <div class="col-md-12">
<iframe width="100%" height="600" src="https://www.youtube.com/embed/_yVcMv0jqFA?si=ilw3Il69yQkUbMCs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
  </section>
  <br>
</app-content>
